import { useState, useEffect, useContext } from 'react'
import { AnexosContext } from '../../../contexts/anexosProvider'
import { UserContext } from '../../../contexts/userProvider'
import DataTable from '../../Table'
import LoadingSpinner from '../../Loader/load'
import LinhasEdit from './linhasEdit'
import { BiX } from "react-icons/bi";
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const Linhas = ({ closeModal, anexo }) => {
    const { linhasByAnexo, deleteLinhaById } = useContext(AnexosContext)
    const { setAlert, isGerente } = useContext(UserContext)
    const [linhas, setLinhas] = useState(null)
    const [linhaSelecionada, setLinhaSelecionada] = useState(null)

    useEffect(() => {
        getLinhas()
    }, [anexo])

    async function getLinhas() {
        const linhas = await linhasByAnexo(anexo.id)
        setLinhas(linhas)
    }

    const visualizar = (linha) => {
        const linhaSelecionada = linhas.find(l => l.id === linha)
        setLinhaSelecionada(linhaSelecionada)
    }

    const deletar = (linha) => {
        if (!linha) return console.error('ID não informado');
        setAlert({
            type: 'confirm',
            placeholder: 'Deseja realmente deletar a linha?',
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteLinhaById(linha),
            params: linha
        })
        getLinhas()
    }



    const headers = [
        { label: "Linha", key: "linha", sortable: true },
        { label: "Operadora", key: "operadora", sortable: false },
        { label: "Status", key: "status", sortable: false },
        { label: "Status Atual", key: "status_atual", sortable: false },
        {
            label: "Ações", key: "actions", sortable: false,
            actions: {
                visualizar,
                ...(isGerente ? { deletar } : {}),
            }
        },
    ]

    const closeEditModal = () => {
        setLinhaSelecionada(null)
        getLinhas()
    }


    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
                {/* Header */}
                <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
                    <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
                        Linhas do anexo {anexo?.nome}
                    </h1>
                    <button 
                        onClick={() => closeModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
                    >
                        <BiX className='w-6 h-6' />
                    </button>
                </div>

                {/* Content */}
                <div className='flex-1 overflow-auto p-6'>
                    {linhas ? (
                        <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                            <DataTable headers={headers} data={linhas} itemsPerPage={10} />
                        </div>
                    ) : (
                        <div className='flex justify-center py-8'>
                            <LoadingSpinner />
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
                    <BaseButton onClick={closeModal} variant="primary" size="md">
                        Fechar
                    </BaseButton>
                </div>

                {/* Modal de edição */}
                {linhaSelecionada && <LinhasEdit closeEditModal={closeEditModal} linha={linhaSelecionada} />}
            </div>
        </div>
    )
}

export default Linhas
